import { render, staticRenderFns } from "./AllDIsputeResolutionSubmissions.vue?vue&type=template&id=29cae0d2&scoped=true&"
import script from "./AllDIsputeResolutionSubmissions.vue?vue&type=script&lang=js&"
export * from "./AllDIsputeResolutionSubmissions.vue?vue&type=script&lang=js&"
import style0 from "./AllDIsputeResolutionSubmissions.vue?vue&type=style&index=0&id=29cae0d2&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "29cae0d2",
  null
  
)

export default component.exports